<div mat-dialog-content class="form-container">
    <form>
        <h2>{{info.nAuth.nombreArchivo}}</h2>
        <div class="documentos-form">
            <p>A continuación debe subir {{info.nAuth.nombreArchivo}}</p>
            <div class="docpropia__drop">
                <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)">
                <ng-template ngx-file-drop-content-tmp 
                let-openFileSelector="openFileSelector">
                <ng-container *ngIf="nameDocumento">{{nameDocumento}}</ng-container>
                <ng-container *ngIf="!nameDocumento">Puedes soltar aquí los documentos o</ng-container>
                <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionar un archivo</button>
                </ng-template>
                </ngx-file-drop>
            </div>
        <div>
        <form [formGroup]="datosDocumento">
        <p>Seleccione la <strong> Fecha de Emisión</strong>: </p>
        <mat-form-field appearance="outline" class="example-form-field">
            <mat-label>Fecha de Emisión</mat-label>
            <input matInput 
                required 
                formControlName="fechaValidez"
                [matDatepicker]="datepicker">
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
            <mat-datepicker-actions>
            <button mat-button matDatepickerCancel>Cancelar</button>
            <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
          </mat-datepicker-actions>
        </mat-datepicker>
      </mat-form-field>
      <p><strong>Caducidad</strong>: <span style="color: red">{{info.nAuth.periocidad}}</span> </p>
        
    </form>
    </div>
</div>
    <div class="boton__siguiente">
      <button
      [disabled]="!nameDocumento || datosDocumento.invalid"
        type="submit"
        [mat-dialog-close]
        (click)="uploadDocumento()"
      >
        Hecho
      </button>
    </div>
</form>

</div>
